import { syntaxTree } from '@codemirror/language';
import { Diagnostic, linter } from '@codemirror/lint';

/**
 * Lightweight syntax error linter using the Lezer parser tree.
 * Detects parse errors for JS/TS/CSS/HTML without requiring ESLint or external tools.
 * Error nodes are marked by Lezer during error recovery — we surface them as inline diagnostics.
 */
export const syntaxErrorLinter = () =>
  linter((view) => {
    const { state } = view;
    const tree = syntaxTree(state as any);
    const diagnostics: Diagnostic[] = [];

    // Only report errors when the parser has finished (tree covers the full document)
    if (tree.length < state.doc.length) return diagnostics;

    let lastErrorEnd = -1;

    tree.iterate({
      enter: (node) => {
        if (node.type.isError) {
          // Skip consecutive/overlapping error nodes (Lezer error recovery noise)
          if (node.from <= lastErrorEnd) return;

          const to = node.to > node.from ? node.to : node.from + 1;
          lastErrorEnd = to;

          diagnostics.push({
            from: node.from,
            to: Math.min(to, state.doc.length),
            severity: 'error',
            message: 'Syntax error',
          });
        }
      },
    });

    return diagnostics;
  });
